import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { errorLogger } from '@utils/errorLogger.util.js';
import { sendUserSurvey } from '../lib/api/sendUserSurvey';

export const useSurveyStore = create((set) => ({
  loading: false,
  error: null,
  result: null,

  sendSurvey: async (data) => {
    set({ loading: true, error: null, result: null });

    try {
      const response = await sendUserSurvey(data);

      if (!response.success) {
        set({ error: response.message, loading: false, result: null });
      }

      set({ result: response, loading: false });
    } catch (error) {
      errorLogger.error(error, { source: useSurveyStore.name });
      set({ error: 'Error. Please, try again.', loading: false, result: null });
    } finally {
      set({ loading: false });
    }
  },
}));

export const useUserSurveyData = () => {
  return useSurveyStore(
    useShallow((state) => ({
      sendSurvey: state.sendSurvey,
      surveyError: state.error,
      isSurveyLoading: state.loading,
      surveyResult: state.result,
    })),
  );
};
